import React from 'react';
import { Navbar, Nav, Container, Button, NavDropdown, Offcanvas, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'; 
import { useNavigate } from 'react-router-dom';
import '../styles/global.css'; 
import { useAuth } from '../contexts/AuthContext'; 
import { useTheme } from '../contexts/ThemeContext'; 
import ThemeToggle from './ThemeToggle'; // <-- ADDED: Importing the sun/moon button
import logo from '../assets/logo.png'; 
import '../styles/AppNavbar.css'; 

function AppNavbar() {
  const { currentUser, logout } = useAuth(); 
  const { theme } = useTheme(); 
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login'); 
  };

  return (
    <Navbar 
      bg={theme === 'light' ? 'white' : 'dark'} // <-- ADDED: Dynamic background color
      variant={theme === 'light' ? 'light' : 'dark'} // <-- ADDED: Dynamic text color
      expand={false} 
      fixed="top" 
      className="shadow-sm border-bottom"
    >
      <Container>
        <LinkContainer to="/">
          <Navbar.Brand className="navbar-brand-custom fw-bold d-flex align-items-center">
            <img
              alt="MultAI Logo"
              src={logo} 
              width="30"
              height="30"
              className="d-inline-block align-top me-2"
              style={{ filter: theme === 'light' ? 'invert(1)' : 'none' }} // <-- PERFECT! You had this right
            />
            MultAI App Studio
          </Navbar.Brand>
        </LinkContainer>
        
        {/* ADDED: This wrapper puts the Dark Mode toggle right next to the Menu button */}
        <div className="d-flex align-items-center gap-3">
          <ThemeToggle /> 
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0 shadow-none" />
        </div>

        <Navbar.Offcanvas
          id="basic-navbar-nav"
          aria-labelledby="basic-navbar-nav-label"
          placement="end"
          className={theme === 'dark' ? 'text-bg-dark' : 'text-bg-light'} // <-- ADDED: Dynamic Menu colors
        >
          <Offcanvas.Header closeButton closeVariant={theme === 'dark' ? 'white' : undefined}>
            <Offcanvas.Title id="basic-navbar-nav-label" className="fw-bold">Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="ms-auto align-items-start">
            {currentUser ? (
              <>
                <LinkContainer to="/dashboard">
                  <Nav.Link className="fs-5 mb-2">Dashboard</Nav.Link>
                </LinkContainer>
                <LinkContainer to="/automation">
                  <Nav.Link className="fs-5 mb-2">Automation Studio</Nav.Link>
                </LinkContainer>
                <NavDropdown 
                  title={<span className="fs-5">{currentUser.full_name || currentUser.email || "Account"}</span>} 
                  id="basic-nav-dropdown"
                  menuVariant={theme === 'dark' ? 'dark' : 'light'}
                >
                  <LinkContainer to="/settings">
                    <NavDropdown.Item>Settings</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/subscribe">
                    <NavDropdown.Item>
                      Membership: <span className="text-warning fw-bold">{currentUser.membership_status || 'NONE'}</span>
                      {currentUser.membership_status !== 'PREMIUM' && ' (Upgrade)'}
                    </NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.ItemText className="px-3">
                    <small className="text-muted">Account Type: {currentUser.account_type || 'USER'}</small>
                  </NavDropdown.ItemText>
                  {currentUser.account_type === 'ADMIN' && (
                    <LinkContainer to="/admin">
                      <NavDropdown.Item>Admin Panel</NavDropdown.Item>
                    </LinkContainer>
                  )}
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={handleLogout} className="text-danger">
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </>
            ) : (
              <>
                <LinkContainer to="/login">
                  <Nav.Link className="fs-5 mb-2">Sign In</Nav.Link>
                </LinkContainer>
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="tooltip-register-disabled">Registration is currently disabled for testing.</Tooltip>}
                >
                  <span className="d-inline-block">
                    <Button variant={theme === 'dark' ? 'outline-light' : 'outline-dark'} className="mt-2 w-100" disabled style={{ pointerEvents: 'none' }}>
                      Register
                    </Button>
                  </span>
                </OverlayTrigger>
                <NavDropdown.Divider className="w-100 my-3" />
                <Nav.Link as="div" className="text-muted small text-uppercase tracking-wider fw-bold mb-2">Site Information</Nav.Link>
                <LinkContainer to="/business-roadmap">
                  <Nav.Link>Business Roadmap</Nav.Link>
                </LinkContainer>
                <LinkContainer to="/feature-roadmap">
                  <Nav.Link>Feature Roadmap</Nav.Link>
                </LinkContainer>
                <LinkContainer to="/changelog">
                  <Nav.Link>Changelog</Nav.Link>
                </LinkContainer>
                <LinkContainer to="/team">
                  <Nav.Link>Team</Nav.Link>
                </LinkContainer>
              </>
            )}
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
}

export default AppNavbar;
